// extracted by mini-css-extract-plugin
export default {"shell":"style_shell__pANcs","copy":"style_copy__pzA0g","kicker":"style_kicker__O+1Hk","title":"style_title__+pwNC","note":"style_note__OEGqh","openButton":"style_openButton__pwLT2"};